import { render } from "./PlaceholderImage.vue?vue&type=template&id=5372f561"
import script from "./PlaceholderImage.vue?vue&type=script&lang=js"
export * from "./PlaceholderImage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__